function hcInitReveals() {
  var els = document.querySelectorAll('.hc-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('hc-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('hc-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { obs.observe(el); });
}

function hcInitGaleria() {
  document.querySelectorAll('.hc-galeria').forEach(function (galeria) {
    var slides = galeria.querySelectorAll('.hc-galeria-media');
    var minis = galeria.querySelectorAll('.hc-galeria-mini');
    if (!slides.length || !minis.length) return;
    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var mediaId = mini.getAttribute('data-media-id');
        slides.forEach(function (slide) {
          slide.classList.toggle('hc-galeria-media-activa', slide.getAttribute('data-media-id') === mediaId);
        });
        minis.forEach(function (m) { m.classList.remove('hc-galeria-mini-activa'); });
        mini.classList.add('hc-galeria-mini-activa');
      });
    });
  });
}

function hcInitVariantes() {
  document.querySelectorAll('[data-hc-producto]').forEach(function (form) {
    var dataEl = form.querySelector('[data-hc-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var idInput = form.querySelector('input[name="id"]');
    var precioEl = form.closest('.hc-comprar-compra')?.querySelector('[data-hc-precio]');
    var precioCompEl = form.closest('.hc-comprar-compra')?.querySelector('[data-hc-precio-comparado]');
    var submitBtn = form.querySelector('[data-hc-submit]');

    function moneyFmt(cents) {
      var pesos = Math.round(cents / 100);
      return '$' + pesos.toLocaleString('es-CO');
    }

    function variantePorOpciones(seleccion) {
      return variantes.find(function (v) {
        return v.options.every(function (opt, i) { return opt === seleccion[i]; });
      });
    }

    function actualizar() {
      var groups = {};
      form.querySelectorAll('[data-hc-opcion]').forEach(function (input) {
        var name = input.getAttribute('name');
        if (input.type === 'radio') {
          if (input.checked) groups[name] = input.value;
        } else {
          groups[name] = input.value;
        }
      });
      var seleccion = Object.keys(groups).map(function (k) { return groups[k]; });
      var v = variantePorOpciones(seleccion);
      if (!v) return;
      idInput.value = v.id;
      if (precioEl) precioEl.textContent = moneyFmt(v.price);
      if (precioCompEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          precioCompEl.textContent = moneyFmt(v.compare_at_price);
          precioCompEl.style.display = '';
        } else {
          precioCompEl.style.display = 'none';
        }
      }
      if (submitBtn) {
        submitBtn.disabled = !v.available;
        submitBtn.textContent = v.available ? submitBtn.getAttribute('data-label-disponible') : submitBtn.getAttribute('data-label-agotado');
      }
      var galeria = form.closest('.hc-comprar-grid')?.querySelector('.hc-galeria');
      if (galeria && v.featured_media_id) {
        var slides = galeria.querySelectorAll('.hc-galeria-media');
        var minis = galeria.querySelectorAll('.hc-galeria-mini');
        var matched = false;
        slides.forEach(function (slide) {
          var isMatch = slide.getAttribute('data-media-id') === String(v.featured_media_id);
          slide.classList.toggle('hc-galeria-media-activa', isMatch);
          if (isMatch) matched = true;
        });
        minis.forEach(function (mini) {
          mini.classList.toggle('hc-galeria-mini-activa', mini.getAttribute('data-media-id') === String(v.featured_media_id));
        });
      }
    }

    form.querySelectorAll('[data-hc-opcion]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var wrapper = sel.closest('.hc-opcion');
        form.querySelectorAll('.hc-opcion').forEach(function (l) { l.classList.remove('hc-opcion-activa'); });
        if (wrapper) wrapper.classList.add('hc-opcion-activa');
        actualizar();
      });
    });
    actualizar();

    function agregarAlCarrito(redirectTo) {
      var formData = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function (res) { return res.json(); })
        .then(function () {
          if (redirectTo) window.location.href = redirectTo;
        })
        .catch(function () {
          form.submit();
        });
    }

    var buyNowBtn = form.querySelector('[data-hc-buy-now]');
    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', function (e) {
        e.preventDefault();
        agregarAlCarrito('/checkout');
      });
    }
    var addToCartBtn = form.querySelector('[data-hc-submit]');
    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', function (e) {
        e.preventDefault();
        agregarAlCarrito('/cart');
      });
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  hcInitReveals();
  hcInitGaleria();
  hcInitVariantes();
});
